import ButtonV2 from "../../../shared/button-v2/button-v2";
import React, {useEffect, useMemo} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import CustomModalV2 from "../../../shared/custom-modal-v2/custom-modal-v2";
import TmdbImage from "../../../shared/tmdb-image/tmdb-image";
import {getLocalDateString, getSerieDates, getYearOfDate} from "../../../../utils/utils";
import TmdbReviewForm from "../tmdb-review-form/tmdb-review-form";

import './tmdb-like-item.scss';

type Props = {
    tmdbItem: any;
    forceDarkMode?: "light" | "dark";
    customUrl?: string;
    onClose?: () => void;
}

const TmdbLikeItem = ({tmdbItem, forceDarkMode, customUrl, onClose}: Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [item, setItem] = React.useState(null);
    const [episode, setEpisode] = React.useState(-1);
    const [season, setSeason] = React.useState(-1);
    const [isMovie, setIsMovie] = React.useState(true);
    const [releaseDate, setReleaseDate] = React.useState(null);

    useEffect(() => {
        if (item?.id && item.id === (tmdbItem.serie?.id ?? tmdbItem.id)) return;
        setItem(tmdbItem?.serie ?? tmdbItem);
        setEpisode(tmdbItem?.episode_number ?? -1);
        setSeason(tmdbItem?.season_number ?? -1);
        setIsMovie(tmdbItem?.isMovie);
        setReleaseDate(tmdbItem?.serie ? tmdbItem?.air_date : tmdbItem?.release_date);
    }, [tmdbItem]);

    const modalIsOpen = location.hash.startsWith(customUrl ?? "#add-review");


    const writingReview = useMemo(() => {
        return location.hash.startsWith(customUrl ?? "#add-review") && location.hash.includes("-write");
    }, [customUrl, location.hash]);

    const handleCloseModal = () => {
        if (writingReview) {
            navigate(-2);
        } else {
            navigate(-1);
        }
        if (onClose) onClose();
    }

    const navigateTo = (path: string) => {
        navigate((customUrl ?? '#add-review') + (path ? ("-" + path) : ''));
    }

    function movieHeader() {
        return (<div className="tmdb-like-item__item-header">
            <TmdbImage className="tmdb-like-item__item-header-img" src={item.poster_path}/>
            <div className="tmdb-like-item__item-header-info">
                <h5 className="tmdb-like-item__item-header-info-title mb-0">
                    {item.title ?? item.name}
                </h5>
                <span className={"text-muted fs-6"}>
                    {releaseDate ? getYearOfDate(releaseDate) : getSerieDates(item)}
                </span>
            </div>
        </div>)
    }

    function serieTvHeader() {
        return (<div className="tmdb-like-item__item-header">
            <TmdbImage className="tmdb-like-item__item-header-img" src={item.poster_path}/>
            <div className="tmdb-like-item__item-header-info">
                <h5 className="tmdb-like-item__item-header-info-title mb-0">
                    S{season}:E{episode} - {item.name}
                </h5>
                <span className={"text-muted fs-6"}>
                    {releaseDate ? getLocalDateString(releaseDate) : 'N/A'}
                </span>
            </div>
        </div>)
    }

    return <>
        <ButtonV2 forceDarkMode={forceDarkMode} width={50} onClick={() => {
            navigate(customUrl ?? "#add-review");
        }} title={"Agregar reseña"}>
            <i className="fa-regular fa-star fa-lg"></i>
        </ButtonV2>
        {item &&
            <CustomModalV2 open={modalIsOpen} title={(episode == -1) ? movieHeader() : serieTvHeader()}
                           onClose={handleCloseModal}>
                <TmdbReviewForm tmdbItem={item} season={season} episode={episode} isMovie={isMovie}
                                handleOpenWriteReview={() => navigateTo("write")} isOpenWriteReview={writingReview}/>
            </CustomModalV2>
        }
    </>;
}

export default TmdbLikeItem;
